'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00246 from "./presto.-Danger-Alert$$anon$6.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00247 from "./presto.-Danger-Alert$$anon$7.js";
var $p;
/** @constructor */
function $c_Lpresto_DangerAlert$$anon$5() {
  this.aJN = null;
  this.aJL = null;
  this.aJM = false;
  this.aJJ = null;
  this.aJK = false;
  this.aJO = false;
  this.aJP = false;
  this.aJN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_DangerAlert$$anon$5 as $c_Lpresto_DangerAlert$$anon$5 };
$p = $c_Lpresto_DangerAlert$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DangerAlert$$anon$5;
/** @constructor */
function $h_Lpresto_DangerAlert$$anon$5() {
}
export { $h_Lpresto_DangerAlert$$anon$5 as $h_Lpresto_DangerAlert$$anon$5 };
$h_Lpresto_DangerAlert$$anon$5.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.aJN;
});
$p.t = (function() {
  if ((!this.aJM)) {
    this.aJL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("groups", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("plans", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aJM = true;
  }
  return this.aJL;
});
$p.ad = (function() {
  if ((!this.aJK)) {
    this.aJJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j1, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00246.$c_Lpresto_DangerAlert$$anon$6()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00247.$c_Lpresto_DangerAlert$$anon$7()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aJK = true;
  }
  return this.aJJ;
});
$p.v = (function() {
  if ((!this.aJP)) {
    this.aJO = false;
    this.aJP = true;
  }
  return this.aJO;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_DangerAlert$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DangerAlert$$anon$5, "presto.DangerAlert$$anon$5", ({
  GQ: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_DangerAlert$$anon$5 as $d_Lpresto_DangerAlert$$anon$5 };
//# sourceMappingURL=presto.-Danger-Alert$$anon$5.js.map
